module.exports = {
  header: {
    title: 'User Profile',
  },
  filter: {
    searchPlaceholder: 'Select User Email',
  },
  validate: {
    email: 'Please input email',
    emailFormat: 'Please enter a valid email',
    selectCountry: 'Please select a country.',
  },
  table: {
    title: {
      description: 'DESCRIPTION',
      value: 'VALUE',
      action: 'ACTION',
      type: 'TYPE',
      model: 'MODEL',
      brand: 'BRAND',
      status: 'STATUS',
    },
    tooltip: {
      edit: 'Edit',
      view: 'View',
      copy: 'Copy',
      activeUser: 'Restore User',
      removeUser: 'Delete User',
      addBlacklist: 'Add to blacklist',
      removeBlacklist: 'Remove from blacklist',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      enable: 'Do you want to enable <bold>{{feature}}</bold>?',
      disable: 'Do you want to disable <bold>{{feature}}</bold>?',
      confirmPassword: 'Please input your password to confirm.',
      activeUser: 'Are you sure you want to restore User?',
      removeUser: 'Are you sure you want to delete User?',
      addBlacklist: 'Are you sure you want to add to blacklist?',
      removeBlacklist: 'Are you sure you want to remove from blacklist?',
      updateUserCountry: 'Are you sure you want to update country?',
    },
  },
  message: {
    activeUser: 'User has been restored.',
    removeUser: 'User has been deleted.',
    addBlacklist: 'User has been added to Blacklist.',
    removeBlacklist: 'User has been removed from Blacklist.',
    userCountry: 'User country updated successfully.',
  },
  err: {
    message: {
      login: 'Wrong email or password.',
      activeUser: 'Unable to restore user.',
      removeUser: 'Unable to delete user.',
      addBlacklist: 'Unable to add user to Blacklist.',
      removeBlacklist: 'Unable to remove user from Blacklist.',
      updateCountry: 'Failed to update country.',
    },
  },
};
